import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    Table,
    Card,
    Typography,
    Spin,
    Select,
    Space
} from 'antd';
import { DiventryBlock } from '../../../../Templates/Layout';
import { useTranslation } from 'react-i18next';
import Brands from '../../Brands/Index'

export function Inventory({ kernel }) {
    const { id } = useParams();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [inventoryData, setInventoryData] = useState([]);

    const [filters, setFilters] = useState({
        period: 'last24h'
    });

    const periods = [
        { value: 'last24h', label: t('Statistics.last24h') },
        { value: 'last30d', label: t('Statistics.last30d') },
        { value: 'last90d', label: t('Statistics.last90d') }
    ];

    useEffect(() => {
        async function fetch() {
            setLoading(true);
            try {
                // Récupérer la liste des appareils
                const devicesResponse = await kernel.api.get(`/dohzel/stats/inventory?profileId=${id}&period=${filters.period}`);
                if (devicesResponse.error) {
                    console.error("Error fetching devices:", devicesResponse.error);
                    setInventoryData([])
                    setLoading(false);
                    return;
                }

                // translate devices
                for (var key in devicesResponse.data.values) {
                    const value = devicesResponse.data.values[key]
                    value.deviceInfo = devicesResponse.data.devices[value.device]
                }

                setInventoryData(devicesResponse.data.values)
            } catch (error) {
                console.error("Error :", error);
                setInventoryData([]);
            } finally {
                setLoading(false);
            }
        };

        fetch();
    }, [id, filters.period]);

    const columns = [
        {
            title: t('Inventory.ip'),
            dataIndex: 'sourceIP',
            key: 'sourceIP',
            sorter: (a, b) => a.sourceIP.localeCompare(b.sourceIP),
            render: (text, record) => {
                return (<strong style={{ fontSize: "1.1em" }}>{text}</strong>)
            },
        },
        {
            title: t('Inventory.name'),
            dataIndex: 'name',
            key: 'name',
            // sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text, record) => {
                return (<Brands.BrandedDevice connectStatus={true} device={record.deviceInfo} />)
            },
        },
        {
            title: t('Inventory.dnsQueries'),
            dataIndex: 'count',
            key: 'count',
            sorter: (a, b) => a.count - b.count,
        },
        {
            title: t('Inventory.blockedThreats'),
            dataIndex: 'blocked',
            key: 'blocked',
            sorter: (a, b) => a.blocked - b.blocked,
        },
        {
            title: t('Inventory.securityThreats'),
            dataIndex: 'security',
            key: 'security',
            sorter: (a, b) => a.security - b.security,
        }
    ];

    return (
        <DiventryBlock>
            <Space.Compact style={{ paddingBottom: 10 }}>
                <Select
                    value={filters.period}
                    style={{ minWidth: 200 }}
                    onChange={(key) => {
                        setFilters({ ...filters, period: key });
                    }}
                    options={periods}
                />
            </Space.Compact>

            <Table
                size="small"
                dataSource={inventoryData}
                columns={columns}
                loading={loading}
                rowKey="id"
            // pagination={{ pageSize: 10 }}
            />

        </DiventryBlock>
    );
}

const styles = {
    filters: {
        marginTop: 20,
        marginBottom: 20
    },
    tableContainer: {
        textAlign: 'left'
    }
};
